import { UpgradePlanBanner } from 'modules/common/components/UpgradePlanBanner';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

export const PrivateChainsTop = () => {
  const { isPremium } = useAccountStatus();

  if (isPremium) {
    return null;
  }

  return <UpgradePlanBanner />;
};
